/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Emergency_TitleInputs */

const en_home_benefit_emergency_title = /** @type {(inputs: Home_Benefit_Emergency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emergency Assistance`)
};

const fr_home_benefit_emergency_title = /** @type {(inputs: Home_Benefit_Emergency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance d'urgence`)
};

/**
* | output |
* | --- |
* | "Emergency Assistance" |
*
* @param {Home_Benefit_Emergency_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_emergency_title = /** @type {((inputs?: Home_Benefit_Emergency_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Emergency_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_emergency_title(inputs)
	return fr_home_benefit_emergency_title(inputs)
});